import { style } from '@angular/animations';

export class AnimationStyleDisplay {
   public static noOpacity = style({
      opacity: 0,
   });

   public static fullOpacity = style({
      opacity: 1,
   });
}
